function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.6148 2.6009C9.85399 2.46637 10.146 2.46637 10.3852 2.6009L18.7662 7.31519C19.0136 7.45436 19.1667 7.71614 19.1667 8V13.7619C19.1667 14.1958 18.8149 14.5476 18.381 14.5476C17.947 14.5476 17.5952 14.1958 17.5952 13.7619V9.34345L10.3852 13.3991C10.146 13.5336 9.85399 13.5336 9.6148 13.3991L1.23385 8.68481C0.986449 8.54565 0.833344 8.28386 0.833344 8C0.833344 7.71614 0.986449 7.45436 1.23385 7.31519L9.6148 2.6009ZM16.7783 8L10 11.8128L3.2217 8L10 4.1872L16.7783 8ZM3.54833 12.8619C3.75612 12.4809 4.23339 12.3405 4.61435 12.5483L10.0158 15.4946L14.8867 13.0591C15.2748 12.8651 15.7468 13.0224 15.9409 13.4105C16.1349 13.7986 15.9776 14.2706 15.5895 14.4647L10.3514 17.0837C10.1213 17.1987 9.84957 17.1939 9.62377 17.0707L3.86186 13.9279C3.48091 13.7201 3.34054 13.2428 3.54833 12.8619Z",
  fill: "#6D6D6D"
});

var SvgOnboarding = function SvgOnboarding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnboarding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Onboarding.355ceea1.svg";
export { ForwardRef as ReactComponent };